import { Card, Col, Row, Stack, Image } from "react-bootstrap";
import { useRef, useState } from "react";
import "./B2BAgents4.css";
import { map } from "lodash";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

export const B2BAgents4 = ({ showExpertise = true, showSupport = true }) => {
  const isDestinationPage = window.location.pathname.includes("/destination");

  const data = [
    {
      Title: "Guided Excursions & Experiences",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/destination%20expertise/guided.png",
    },
    {
      Title: "Local Knowledge",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/destination%20expertise/local%20knowledge.webp",
    },
    {
      Title: "Local Networks & Market Insights",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/destination%20expertise/local%20connection.webp",
    },
    {
      Title: "Logistics & Ground Handling Services",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/destination%20expertise/logistic.webp",
    },
  ];

  const sliderRef = useRef(null);
  const [slideIndex, setSlideIndex] = useState(0);

  const support = [
    {
      id: 1,
      title: "FREE CALL SUPPORT",
      icon: "/assets/live-icon1.svg",
      desc: "Need expert assistance for your next booking or preparing itineraries? Our B2B specialists are just a call away—free of charge!",
      link: "tel:+971559886749",
    },
    {
      id: 2,
      title: "24/7 LIVE CHAT",
      icon: "/assets/live-icon2.svg",
      desc: "Get real-time support for reservations, supplier coordination, and urgent requests with our round-the-clock B2B live chat service!",
      link: "https://wa.me/+971559886749",
    },
  ];

  return (
    <>
      {showExpertise && !isDestinationPage && (
        <div className="b2b4Agents standard-padding">
          <Row>
            <Col lg={5}>
              <Stack className="b2b4Agents-container">
                <div className="d-flex flex-column">
                  <h1 className="heading mb-4 b2b4Agents-container-heading">
                    Destination Expertise For B2B Travel
                  </h1>

                  <p className="text text-align-mobile">
                    At Blueberry DMC, our strength comes from being truly on the
                    ground. We work directly with local suppliers, transport
                    providers, and hotels — not through intermediaries. This
                    gives our partners transparent pricing, faster
                    confirmations, and dependable operations. Our regional teams
                    understand market behavior, seasonality, and traveler
                    expectations, helping you design products that actually
                    sell. Partner with us to combine authentic experiences with
                    operational reliability that drives business growth.
                  </p>
                </div>

                {/* DESKTOP ARROWS */}
                <Stack
                  gap={3}
                  direction="horizontal"
                  className="b2b4agents-sliderArrow d-none d-lg-flex"
                >
                  <div
                    className="b2b4Agents-slider-arrows"
                    onClick={() => sliderRef.current?.slidePrev()}
                  >
                    <IoChevronBack className="b2b4Agents-slider-icon" />
                  </div>

                  <div
                    className="b2b4Agents-slider-arrows"
                    onClick={() => sliderRef.current?.slideNext()}
                  >
                    <IoChevronForward className="b2b4Agents-slider-icon" />
                  </div>
                </Stack>
              </Stack>
            </Col>

            <Col lg={7}>
              <Swiper
                modules={[Navigation]}
                spaceBetween={0}
                slidesPerView={3}
                onSlideChange={(swiper) => setSlideIndex(swiper.activeIndex)}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  1300: {
                    slidesPerView: 3,
                  },
                }}
                onSwiper={(swiper) => {
                  sliderRef.current = swiper;
                }}
                className="b2b4Agents-swiper"
              >
                {map(data, (deal, index) => (
                  <SwiperSlide key={index}>
                    <div className="b2b4Agents-card-container d-flex justify-content-center gap-1">
                      <Card
                        className="b2b4Agents-card"
                        style={{
                          backgroundImage: `url(${deal.ImagePath})`,
                        }}
                      >
                        <div className="b2b4Agents-img-body"></div>

                        <Card.Body className="text-center b2b4Agents-title-div">
                          <Card.Title className="b2b4Agents-title pt-4">
                            {deal.Title}
                          </Card.Title>
                        </Card.Body>
                      </Card>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>

            {/* MOBILE/TAB ARROWS */}
            <Stack
              gap={3}
              direction="horizontal"
              className="b2b4agents-sliderArrow justify-content-center d-lg-none"
            >
              <div
                className="b2b4Agents-slider-arrows"
                onClick={() => sliderRef.current?.slidePrev()}
              >
                <IoChevronBack className="b2b4Agents-slider-icon" />
              </div>

              <div
                className="b2b4Agents-slider-arrows"
                onClick={() => sliderRef.current?.slideNext()}
              >
                <IoChevronForward className="b2b4Agents-slider-icon" />
              </div>
            </Stack>
          </Row>
        </div>
      )}

      {/* SUPPORT SECTION */}
      {showSupport && (
        <>
          {/* SUPPORT SECTION */}
          <div
            className="b2b4AgentsSec4 standard-padding"
            style={{
              backgroundColor: "#F2F2F2",
              marginBottom: isDestinationPage ? "0" : undefined,
            }}
          >
            <h1 className="heading mb-4">24/7 Online Live Support</h1>

            <div className="b2b4AgentsSec-row">
              {map(support, (d) => (
                <a
                  key={d.id}
                  href={d.link}
                  target={d.id === 2 ? "_blank" : ""}
                  rel="noopener noreferrer"
                  className="b2b4AgentsSec4-card2"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <Stack>
                    <Stack direction="horizontal" gap={3}>
                      <Stack className="b2b4AgentsSec4-icon">
                        <Image className="b2b4AgentsSec4-img" src={d.icon} />
                      </Stack>

                      <Stack className="b2b4AgentsSec4-padding">
                        <h4 className="b2b4AgentsSec4-title">{d.title}</h4>

                        <p className="b2b4AgentsSec4-desc">{d.desc}</p>
                      </Stack>
                    </Stack>
                  </Stack>
                </a>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};
